export const CHIP_ITEM_TYPE = 'CC'
export const PEEL_STICK_ITEM_TYPE = 'PS'
export const LIMIT_CART_CHIP = 12
export const LIMIT_ITEM_CHIP = 12
export const LIMIT_CART_PEEL_STICK = Infinity
export const LIMIT_ITEM_PEEL_STICK = 99
export const PS_BUNDLE_ITEM_TYPE = 'PSB'
